import XLSX from 'xlsx'
import FileSaver from 'file-saver';

const moment = require("moment");
const moment_tz = require("moment-timezone");

const excel = {};

excel.newWorkBook = function() {
    return XLSX.utils.book_new();
};

excel.addWorkSheet = function(workbook, sheetName, aoaData) {
    if (aoaData && aoaData.length > 0) {
        const worksheet = XLSX.utils.aoa_to_sheet(aoaData);
        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
        return worksheet;
    }
    return null;
}

excel.setColSizes = function(worksheet, colSizes) {
    worksheet['!cols'] = colSizes.map((size, i) => ({ wch: size }));
}

excel.saveFile = function(workbook, fileName) {
    if (workbook) {
        const wbOut = XLSX.write(workbook, { booktype:'xlsx', bookSST:false, type:'array' });
        FileSaver.saveAs(new Blob([wbOut], {type:"application/octet-stream"}), fileName + ".xlsx");
    }
};

excel.readFile = function(file, onJsonLoaded) {
    if (file) {
        const reader = new FileReader();
        reader.onload = function() {
            const wb = XLSX.read(reader.result, { type: "binary", cellDates:true });
            if (wb.SheetNames.length > 0) {
                const ws = wb.Sheets[wb.SheetNames[0]];
                onJsonLoaded(XLSX.utils.sheet_to_json(ws));
            }
        };
        reader.readAsBinaryString(file);
    }
};

excel.downloadOrder = function(vue, items, fileName) {
    const aoa = [];
    aoa.push(["#", "판매처", "업체", "담당센터", "담당기사", "타입", "주문날짜", "상품명", "수량", "주문자", "주문자연락처", "수취인", "수취인연락처", "수취인주소", "고객요청사항", "설치유형", ]);

    const partners = {};
    const totalCounts = {};

    let index = 1;
    for (const item of items) {

        let centerName = "";
        for (const center of vue.centers) {
            if (center._id == item._center) {
                centerName = center.name;
            }
        }
        let workerName = "";
        for (const worker of vue.workers) {
            if (worker._id == item._worker) {
                workerName = worker.name;
            }
        }
        aoa.push([ index++, item.seller, item.partnerName, centerName, workerName, vue.constantNames[item.type], new Date(item.orderedAt).format("yyyy-MM-dd"),
            item.product, item.count, item.orderer, item.ordererTel, item.receiver, item.receiverTel, item.address, item.clientMemo, item.partnerMemo, ]);

        if (!partners[item.partnerName]) partners[item.partnerName] = {};
        if (!partners[item.partnerName][item.product]) partners[item.partnerName][item.product] = 0;
        partners[item.partnerName][item.product] += parseInt(item.count);

        if (!totalCounts[item.partnerName]) totalCounts[item.partnerName] = 0;
        totalCounts[item.partnerName] += parseInt(item.count);
    }

    for (const name in partners) {
        aoa.push([]);
        aoa.push([ "", "", name, "", "", "", "", "상품명", "합계" ]);
        for (const product in partners[name]) {
            aoa.push([ "", "", "", "", "", "", "", product, partners[name][product] ]);
        }
        aoa.push([ "", "", "", "", "", "", "", "총합계", totalCounts[name] ]);
    }

    const wb = excel.newWorkBook();
    const ws = excel.addWorkSheet(wb, "sheet", aoa);
    excel.setColSizes(ws, [ 4, 12, 12, 10, 10, 4, 15, 25, 4, 8, 15, 8, 15, 50, 20, 20, 20, ]);
    excel.saveFile(wb, fileName);
}

excel.downloadOrderedItem = function(vue, items, fileName) {
    const aoa = [];
    aoa.push(["#", "업체", "타입", "주문날짜", "상품명", "수량", "수취인", "수취인연락처", "배송기사", "수취인주소", "고객요청사항", "설치유형" ]);

    const partners = {};
    const totalCounts = {};

    let index = 1;
    for (const item of items)
    {
        aoa.push([ index++, item.partnerName, vue.constantNames[item.type], new Date(item.orderedAt).format("yyyy-MM-dd"),
            item.product, item.count, item.receiver, item.receiverTel, item.workerName, item.address, item.clientMemo, item.partnerMemo, ]);

        if (!partners[item.partnerName]) partners[item.partnerName] = {};
        if (!partners[item.partnerName][item.product]) partners[item.partnerName][item.product] = 0;
        partners[item.partnerName][item.product] += parseInt(item.count);

        if (!totalCounts[item.partnerName]) totalCounts[item.partnerName] = 0;
        totalCounts[item.partnerName] += parseInt(item.count);
    }

    for (const name in partners) {
        aoa.push([]);
        aoa.push([ "", "", "", "", name, "합계" ]);
        for (const product in partners[name]) {
            aoa.push([ "", "", "", "", product, partners[name][product] ]);
        }
        aoa.push([ "", "", "", "", "총합계", totalCounts[name] ]);
    }

    const wb = excel.newWorkBook();
    const ws = excel.addWorkSheet(wb, "sheet", aoa);
    excel.setColSizes(ws, [ 4, 12, 4, 15, 25, 4, 8, 15, 10, 50, 20, 20, 20, ]);
    excel.saveFile(wb, fileName);
}

excel.downloadFinishedItem = function(vue, items, fileName) {

    const dateName = vue.constantNames[items[0].status] + "날짜";
    const dateFormat = "yyyy-MM-dd HH:mm";

    const aoa = [];
    aoa.push(["#", "판매처", "업체", "담당기사", "타입", "주문날짜", dateName, "상품명", "수량", "주문자", "주문자연락처", "수취인", "수취인연락처", "수취인주소", "고객요청사항", "설치유형", "코멘트" ]);

    const partners = {};
    const totalCounts = {};

    let index = 1;
    for (const item of items)
    {
        const orderedAt = moment.tz(item.orderedAt, "Asia/Seoul").toDate();

        const createdAt = moment.tz(item.createdAt, "Asia/Seoul").toDate();

        aoa.push([ index++, item.seller, item.partnerName, item.workerName, vue.constantNames[item.type], orderedAt.format(dateFormat), createdAt.format(dateFormat),
            item.product, item.count, item.orderer, item.ordererTel, item.receiver, item.receiverTel, item.address, item.clientMemo, item.partnerMemo, item.comment, ]);

        if (!partners[item.partnerName]) partners[item.partnerName] = {};
        if (!partners[item.partnerName][item.product]) partners[item.partnerName][item.product] = 0;
        partners[item.partnerName][item.product] += parseInt(item.count);

        if (!totalCounts[item.partnerName]) totalCounts[item.partnerName] = 0;
        totalCounts[item.partnerName] += parseInt(item.count);
    }

    for (const name in partners) {
        aoa.push([]);
        aoa.push([ "", "", name, "", "", "상품명", "수량" ]);
        for (const product in partners[name]) {
            aoa.push([ "", "", "", "", "", product, partners[name][product] ]);
        }
        aoa.push([ "", "", "", "", "", "총합계", totalCounts[name] ]);
    }

    const wb = excel.newWorkBook();
    const ws = excel.addWorkSheet(wb, "sheet", aoa);
    excel.setColSizes(ws, [ 4, 8, 12, 8, 4, 20, 20, 20, 4, 8, 15, 8, 15, 50, 20, 20, 20, ]);
    excel.saveFile(wb, fileName);
}

excel.downloadParcel = function(vue, items, fileName) {
    const aoa = [];
    aoa.push(["#", "판매처", "업체", "운송장번호", "택배사", "타입", "주문날짜", "완료날짜", "상품명", "수량", "주문자", "주문자연락처", "수취인", "수취인연락처", "수취인주소", "고객요청사항", "설치유형", "취소사유" ]);

    const partners = {};
    const totalCounts = {};

    let index = 1;
    for (const item of items) {
        const typeName = vue.constantNames[item.type];
        const orderedDate = new Date(item.orderedAt).format("yyyy-MM-dd");
        const createdDate = new Date(item.createdAt).format("yyyy-MM-dd");
        
        aoa.push([ index++, item.seller, item.partnerName, item.number, item.company, typeName, orderedDate, createdDate, item.product, item.count,
            item.orderer, item.ordererTel, item.receiver, item.receiverTel, item.address, item.clientMemo, item.partnerMemo, item.comment, ]);

        if (!partners[item.partnerName]) partners[item.partnerName] = {};
        if (!partners[item.partnerName][item.product]) partners[item.partnerName][item.product] = 0;
        partners[item.partnerName][item.product] += parseInt(item.count);

        if (!totalCounts[item.partnerName]) totalCounts[item.partnerName] = 0;
        totalCounts[item.partnerName] += parseInt(item.count);
    }

    for (const name in partners) {
        aoa.push([]);
        aoa.push([ "", "", name, "", "", "상품명", "수량" ]);
        for (const product in partners[name]) {
            aoa.push([ "", "", "", "", "", product, partners[name][product] ]);
        }
        aoa.push([ "", "", "", "", "", "총합계", totalCounts[name] ]);
    }

    const wb = excel.newWorkBook();
    const ws = excel.addWorkSheet(wb, "sheet", aoa);
    excel.setColSizes(ws, [ 4, 8, 12, 12, 8, 4, 12, 12, 12, 4, 8, 15, 8, 15, 50, 20, 20, 20, ]);
    excel.saveFile(wb, fileName);
}

excel.downloadProduct = function(vue, partnerName)
{
    const aoa = [];
    const titleRow = [];
    {
        titleRow.push("#");
        titleRow.push("규격");
        titleRow.push("상품명");
        for (const center of vue.centers)
        {
            if (!center.isTerminated) titleRow.push(center.name);
        }
        titleRow.push("합계");
    }
    aoa.push(titleRow);

    let index = 1;
    for (const product of vue.products) {

        if (product.isTerminated) continue;

        const row = [];
        row.push(index++);
        row.push(product.description);
        row.push(product.name);
        for (const center of vue.centers)
        {
            if (!center.isTerminated) row.push(product.centerStocks[center._id].count);
        }
        row.push(product.totalCount);
        aoa.push(row);
    }

    let sumRow = [];
    {
        sumRow.push("");
        sumRow.push("");
        sumRow.push("합계");
        for (const center of vue.centers)
        {
            if (!center.isTerminated) sumRow.push(vue.centerTotalCounts[center._id]);
        }
        sumRow.push(vue.getAllTotalCount());
    }
    aoa.push(sumRow);

    const wb = excel.newWorkBook();
    const ws = excel.addWorkSheet(wb, "sheet", aoa);
    excel.setColSizes(ws, [ 4, 10, 30, 10, 10, 10, 10, 10, 10, 10, 10 ]);
    excel.saveFile(wb, new Date().format("yyyyMMdd_hhmm_") + partnerName + "_재고");
}

excel.downloadAllProducts = function(vue, allProducts)
{
    const aoa = [];
    const titleRow = [];
    {
        titleRow.push("#");
        titleRow.push("규격");
        titleRow.push("상품명");
        for (const center of vue.centers)
        {
            if (!center.isTerminated)
            {
                titleRow.push(center.name);
            }
        }
        titleRow.push("합계");
    }
    aoa.push(titleRow);

    for (const partnerName in allProducts)
    {
        let allProductCount = 0;

        let centerAllProductCounts = {};

        const products = allProducts[partnerName];

        aoa.push([]);
        aoa.push([ "", partnerName ]);
        aoa.push([]);

        let index = 1;
        for (const product of products)
        {
            if (product.isTerminated) continue;

            const row = [];
            row.push(index++);
            row.push(product.description);
            row.push(product.name);

            let centerSum = 0;
            for (const center of vue.centers)
            {
                if (!center.isTerminated) 
                {
                    if (!centerAllProductCounts[center.id]) centerAllProductCounts[center.id] = 0;
                    if (!product.centerStocks[center._id]) product.centerStocks[center._id] = {};
                    if (!product.centerStocks[center._id].count) product.centerStocks[center._id].count = 0;

                    centerAllProductCounts[center.id] += product.centerStocks[center._id].count;

                    centerSum += product.centerStocks[center._id].count;

                    row.push(product.centerStocks[center._id].count);
                }
            }
            row.push(centerSum);
            aoa.push(row);

            allProductCount += centerSum;
        }

        let sumRow = [];
        {
            sumRow.push("");
            sumRow.push("");
            sumRow.push("합계");
            for (const centerId in centerAllProductCounts)
            {
                sumRow.push(centerAllProductCounts[centerId]);
            }
            sumRow.push(allProductCount);
        }
        aoa.push(sumRow);
    }

    const wb = excel.newWorkBook();
    const ws = excel.addWorkSheet(wb, "sheet", aoa);
    excel.setColSizes(ws, [ 4, 15, 30, 10, 10, 10, 10, 10, 10, 10, 10 ]);
    excel.saveFile(wb, new Date().format("yyyyMMdd_hhmm_") + "_재고");
}

excel.downloadCalculate = function(vue, items, fileName) {

    const dateFormat = "yyyy-MM-dd HH:mm";

    const aoa = [];
    aoa.push(["#", "판매처", "업체", "주문날짜", "완료날짜", "규격", "상품명", "수량", "타입", "주문자", "수취인", "주소", "센터", "담당기사", "지역", "설치유형", "코멘트", "고객요청", "설치공급가", "설치부가세", "브라켓공급가", "브라켓부가세", "도선료", "합계"  ]);

    let index = 1;
    for (const item of items)
    {
        item.price *= item.count;
        item.extraPrice *= item.count;
        item.ferriage = excel.getFerriage(item.region2);

        const orderedAtText = moment.tz(item.orderedAt, "Asia/Seoul").toDate().format(dateFormat);
        const createdAtText = moment.tz(item.createdAt, "Asia/Seoul").toDate().format(dateFormat);
        const type = vue.constantNames[item.type];
        const unitPrice = parseInt(item.price * 0.9);
        const unitTex = parseInt(item.price * 0.1);
        const unitExtraPrice = parseInt(item.extraPrice * 0.9);
        const unitExtraTex = parseInt(item.extraPrice * 0.1);

        aoa.push([ index++, item.seller, item.partnerName, orderedAtText, createdAtText, item.productDescription, item.product, item.count, type, 
            item.orderer, item.receiver, item.address, item.centerName, item.workerName, item.region, item.partnerMemo, item.comment, item.clientMemo,
            unitPrice, unitTex, unitExtraPrice, unitExtraTex, item.ferriage, item.price + item.extraPrice + item.ferriage]);
    }

    const wb = excel.newWorkBook();
    const ws = excel.addWorkSheet(wb, "sheet", aoa);
    excel.setColSizes(ws, [ 4, 8, 12, 15, 15, 6, 20, 4, 4, 12, 12, 30, 8, 8, 8, 12, 12, 12, 12, 12, 12, 12, 12, ]);
    excel.saveFile(wb, fileName);
}

excel.downloadCalculateParcel = function(vue, items, fileName) {

    const dateFormat = "yyyy-MM-dd HH:mm";

    const aoa = [];
    aoa.push(["#", "판매처", "업체", "택배사", "주문날짜", "완료날짜", "송장번호", "규격", "상품명", "수량", "타입", "주문자", "수취인", "주소", "지역", "택배공급가", "택배부가세", "상품공급가", "상품부가세", "도선료", "합계"  ]);

    let index = 1;
    for (const item of items) {
        const orderedAtText = moment.tz(item.orderedAt, "Asia/Seoul").toDate().format(dateFormat);
        const createdAtText = moment.tz(item.createdAt, "Asia/Seoul").toDate().format(dateFormat);
        const type = vue.constantNames[item.type];
        const unitPrice = parseInt(item.price * 0.9);
        const unitTex = parseInt(item.price * 0.1);
        const goodsPrice = parseInt(item.goodsPrice * 0.9);
        const goodsTex = parseInt(item.goodsPrice * 0.1);

        aoa.push([ index++, item.seller, item.partnerName, item.company, orderedAtText, createdAtText, item.number, item.productDescription, item.product, item.count, type, 
            item.orderer, item.receiver, item.address, item.region, unitPrice, unitTex, goodsPrice, goodsTex, item.ferriage, item.price + item.goodsPrice + item.ferriage]);
    }

    const wb = excel.newWorkBook();
    const ws = excel.addWorkSheet(wb, "sheet", aoa);
    excel.setColSizes(ws, [ 4, 12, 12, 8, 15, 15, 15, 6, 20, 4, 4, 12, 12, 30, 8, 10, 10, 10, 10, 10, 10, ]);
    excel.saveFile(wb, fileName);
}

excel.downloadStockOrders = function(vue, stockOrders, fileName) {
    const aoa = [];
    aoa.push(["#", "날짜", "업체", "유형", "상품명", "수량", "메모" ]);

    let index = 1;
    for (const order of stockOrders) {
        const typeName = vue.constantNames[order.type];
        const date = new Date(order.createdAt).format("yyyy-MM-dd");
        const partnerName = vue.getPartner(order._partner).name;
        for (const product of order.products) {
            aoa.push([ index++, date, partnerName, typeName, product.name, product.count, product.memo ]);   
        }
    }

    const wb = excel.newWorkBook();
    const ws = excel.addWorkSheet(wb, "sheet", aoa);
    excel.setColSizes(ws, [ 4, 12, 20, 6, 20, 5, 40, ]);
    excel.saveFile(wb, fileName);
}

excel.install = function(Vue) {
    Vue.prototype.$excel = excel;
};

excel.getFerriage = function(region)
{
    // if (/영종도/g.test(region) || 
    //     /무의도/g.test(region) || 
    //     /영흥도/g.test(region) || 
    //     /교동도/g.test(region) || 
    //     /석모도/g.test(region) || 
    //     /선재/g.test(region) || 
    //     /죽도/g.test(region) || 
    //     /소무의도/g.test(region) || 
    //     /실미도/g.test(region) || 
    //     /강화도/g.test(region) || 
    //     /태안/g.test(region) || 
    //     /보령/g.test(region) || 
    //     /서산시/g.test(region) || 
    //     /가덕도/g.test(region) || 
    //     /거제도/g.test(region) || 
    //     /통영/g.test(region) || 
    //     /산청/g.test(region) || 
    //     /함영/g.test(region) || 
    //     /거창/g.test(region) || 
    //     /진주/g.test(region) || 
    //     /하동/g.test(region) || 
    //     /군산시/g.test(region) || 
    //     /부안군/g.test(region) || 
    //     /고창군/g.test(region) || 
    //     /무안군/g.test(region) || 
    //     /신안군/g.test(region) || 
    //     /목포시/g.test(region) || 
    //     /진도군/g.test(region) || 
    //     /해남군/g.test(region) || 
    //     /완도군/g.test(region) || 
    //     /고흥군/g.test(region) || 
    //     /여수시/g.test(region) || 
    //     /울진/g.test(region) || 
    //     /영덕/g.test(region) || 
    //     /포항/g.test(region) || 
    //     /영주/g.test(region) || 
    //     /봉화/g.test(region) || 
    //     /영양군/g.test(region) || 
    //     /고성군/g.test(region) || 
    //     /속초시/g.test(region) || 
    //     /양양군/g.test(region) || 
    //     /삼척시/g.test(region) || 
    //     /동해시/g.test(region) || 
    //     /태백시/g.test(region) || 
    //     /정선군/g.test(region) || 
    //     /영월군/g.test(region))
    // {
    //     return 20000;
    // }
    return 0;
}

export default excel;


// WEBPACK FOOTER //
// ./src/excel.js